import Header from "./components/Header";
import Hero from "./components/Hero";
import CompanyIntro from "./components/CompanyIntro";
import Services from "./components/Services";
import CompanyOverview from "./components/CompanyOverview";
import Qualifications from "./components/Qualifications";
import ContactForm from "./components/ContactForm";
import Footer from "./components/Footer";

export default function Home() {
  return (
    <div className="bg-navy min-h-screen" style={{ fontFamily: "'Noto Sans JP', sans-serif" }}>
      <Header />
      <main>
        <section><Hero /></section>
        <section><CompanyIntro /></section>
        <section><Services /></section>
        <section><CompanyOverview /></section>
        <section><Qualifications /></section>
        <ContactForm />
      </main>
      <Footer />
    </div>
  );
}
